@if (config) {
<div class="tl-card">

  <!-- Header -->
  @if (config.title) {
  <div class="tl-card__header">
    @if (config.headerIcon) {
      <span class="tl-card__header-icon">
        <i class="pi {{ config.headerIcon }}"></i>
      </span>
    } @else {
      <span class="tl-card__dot"></span>
    }
    <h4 class="tl-card__title">{{ config.title }}</h4>
    @if (config.valueLabel) {
      <span class="tl-card__unit">{{ config.valueLabel }}</span>
    }
  </div>
  }

  <!-- Timeline -->
  <div class="tl-body">
    @for (event of config.events; track event.label; let last = $last) {

      <div class="tl-row" [class.tl-row--highlight]="event.highlight">

        <!-- Conector vertical + nodo -->
        <div class="tl-connector">
          <div class="tl-connector__line" [class.tl-connector__line--last]="last"></div>
          <div class="tl-connector__node"
               [style.background]="event.highlight ? accent : 'var(--cc-divider)'"
               [style.box-shadow]="event.highlight ? '0 0 10px ' + accent + '88' : 'none'">
            @if (event.highlight) {
              <i class="pi pi-star-fill"></i>
            }
          </div>
        </div>

        <!-- Contenido -->
        <div class="tl-content">
          <div class="tl-content__top">
            <span class="tl-content__label">{{ event.label }}</span>
            <span class="tl-content__value"
                  [style.color]="event.highlight ? accent : 'var(--cc-text-primary)'"
                  [style.text-shadow]="event.highlight ? '0 0 12px ' + accent + '66' : 'none'">
              {{ fmt(event.value) }}
            </span>
          </div>

          <!-- Barra horizontal proporcional -->
          <div class="tl-content__bar-track">
            <div class="tl-content__bar-fill"
                 [style.width]="barWidth(event.value)"
                 [style.background]="event.highlight ? accent : 'var(--cc-divider)'"
                 [style.box-shadow]="event.highlight ? '0 0 8px ' + accent + '66' : 'none'">
            </div>
          </div>

          @if (event.sublabel) {
            <span class="tl-content__sublabel">{{ event.sublabel }}</span>
          }
        </div>

      </div>

    }
  </div>

</div>
}
